<template>
  <section v-if="mode === 'off'" class="c4-camalt" data-cam="off">
    <span class="tile info"><i class="mdi mdi-barcode-scan" aria-hidden="true"></i></span>
    <h3>{{ tx("cam.off") }}</h3>
    <div class="c4-camalt-p">{{ tx("cam.off_sub") }}</div>
    <button type="button" class="c4-btn ghost sm" @click="$emit('enable')">
      <i class="mdi mdi-camera-outline" aria-hidden="true"></i>{{ tx("cam.enable") }}
    </button>
  </section>

  <section v-else-if="problem" class="c4-camalt" :data-cam="problem">
    <span class="tile" :class="{ bad: problem === 'none' }">
      <i class="mdi" :class="problem === 'busy' ? 'mdi-alert-outline' : 'mdi-camera-off-outline'" aria-hidden="true"></i>
    </span>
    <h3>{{ tx("cam." + problem) }}</h3>
    <div class="c4-camalt-p">{{ tx("cam." + problem + "_sub") }}</div>
    <button type="button" class="c4-btn brand sm" data-fk="camfix" @click="retry">
      <i class="mdi mdi-refresh" aria-hidden="true"></i>{{ tx("cam.retry") }}
    </button>
  </section>

  <section v-else class="c4-cam" :class="{ off: !ready }" :aria-label="tx('id.camera')" data-cam="on">
    <div class="c4-cam-feed">
      <qrcode-stream
        :key="streamKey"
        :camera="facing"
        :track="false"
        @decode="onDecode"
        @init="onInit"
      ></qrcode-stream>
    </div>
    <div class="c4-cam-fr" aria-hidden="true"><i></i><i></i><i></i><i></i></div>
    <div class="c4-cam-scan" aria-hidden="true"></div>
    <span class="c4-cam-tag"><i></i>{{ tx("cam.live") }}</span>
    <button type="button" class="c4-cam-b" data-fk="flip" :aria-label="tx('cam.flip')" @click="flip">
      <i class="mdi mdi-camera-flip-outline" aria-hidden="true"></i>
    </button>
    <template v-if="coolLeft != null && !busy">
      <span class="c4-cam-ring">
        <svg :key="ringKey" class="c4-ring" viewBox="0 0 100 100" :style="{ '--rt': coolTotal + 's' }" aria-hidden="true">
          <circle class="bg" cx="50" cy="50" r="45" />
          <circle class="fg" cx="50" cy="50" r="45" />
        </svg>
        <b>{{ coolLeft }}</b>
      </span>
      <div class="c4-cam-ct">{{ tx("sig.wait_sub") }}</div>
    </template>
    <span v-else-if="hint" class="c4-cam-h">
      <i class="mdi" :class="hint.icon" aria-hidden="true"></i>{{ hint.text }}
    </span>
  </section>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenScanner",
  mixins: [canteenV4Text],
  components: { QrcodeStream },
  props: {
    // on = kamera, off = samo čitač (bez traženja dozvole za kameru)
    mode: { type: String, default: "on" },
    // ishod se prihvata samo kad je signal zelen; u pauzi se skeniranje ignoriše
    ready: { type: Boolean, default: true },
    busy: { type: Boolean, default: false },
    waitNext: { type: Boolean, default: false },
    coolLeft: { type: Number, default: null },
    coolTotal: { type: Number, default: 0 },
    ringKey: { type: [Number, String], default: 0 },
  },
  data() {
    return { problem: "", facing: "auto", streamKey: 0 };
  },
  computed: {
    hint() {
      if (this.busy) return { icon: "mdi-cached c4-spin", text: this.tx("sig.busy") };
      if (this.waitNext) return { icon: "mdi-plus", text: this.tx("sig.manual_sub") };
      if (!this.ready) return null;
      return { icon: "mdi-qrcode-scan", text: this.tx("cam.hint") };
    },
  },
  methods: {
    onDecode(raw) {
      if (this.ready) this.$emit("decode", raw);
    },
    onInit(promise) {
      promise
        .then(() => {
          this.problem = "";
          this.$emit("state", "ok");
        })
        .catch((error) => {
          const name = error && error.name;
          let problem = "none";
          if (name === "NotAllowedError") problem = "denied";
          else if (name === "NotReadableError" || name === "TrackStartError") problem = "busy";
          else if (name === "InsecureContextError" || name === "StreamApiNotSupportedError") problem = "insecure";
          else if (name === "OverconstrainedError") {
            // zadnja/prednja kamera ne postoji: pokušaj bilo koju
            if (this.facing !== "auto") {
              this.facing = "auto";
              return;
            }
          }
          this.problem = problem;
          this.$emit("state", problem);
        });
    },
    retry() {
      this.problem = "";
      this.streamKey++;
    },
    flip() {
      this.facing = this.facing === "front" ? "rear" : "front";
    },
  },
};
</script>
